<template lang="pug">
  v-container.dataview(v-if="dataready")
    Breadcrumbs(:data="breadcrumbs")
    Heading(
      :title="dataview.title"
      :description="dataview.description"
      :lastUpdate="dataview.last_update"
      :url="dataview.query_url"
      :query-explanation="dataview.query_explanation"
      show-view-details
    )
    v-card(outlined).mt-3
      div(v-if="dataview.query_url")
        ExternallyPaginatedTable(
          :url="$route.query.token ? `${dataview.query_url}?token=${$route.query.token}` : dataview.query_url"
          :number-of-records="dataset.number_of_records"
          v-if="isDatahubDataset"
        )
        ExternalTable(v-else :url="query_url_s3")
      p.text-center.ma-2(v-else-if="dataset.visibility=='protected' && !dataset.last_update") Dataset is protected, invalid access token provided.
      p.text-center.ma-2(v-else) No datasource set for this view.
</template>

<script>
import service from '../data/service'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import ExternallyPaginatedTable from '@/components/ExternallyPaginatedTable.vue'
import ExternalTable from '@/components/ExternalTable.vue'
import Heading from '@/components/Heading.vue'
import moment from 'moment'

export default {
  data: () => ({
    dataset: {},
    dataview: {},
    dataready: false
  }),
  components: {
    Breadcrumbs,
    ExternallyPaginatedTable,
    ExternalTable,
    Heading
  },
  computed: {
    query_url_s3() {
      return this.dataview.query_url + "?v=" + (this.dataset.s3Details ?  moment(this.dataset.s3Details.LastModified).unix() : moment().unix());
    },
    breadcrumbs() {
      let result = []
      if(this.dataset.id){
        if(this.dataset.collection)
          result.push({
            text: this.dataset.collection.title,
            to: { name: 'collection', params: { id: this.dataset.collection.id }},
            super: 'Collection'
          })
        result.push({
          text: this.dataset.title,
          to: { name: 'dataset', params: { id: this.dataset.id }, query: { tab: '0' }},
          super: 'Dataset'
        })
      }
      return result
    },
    isDatahubDataset() {
      if(this.dataview.query_url && this.dataview.query_url.slice(0,38) == "https://datahub-v2.arlingtonva.us/api/")
        return true
      return false
    }
  },
  methods: {
    getData() {
      return service.getDataset(this.$route.params.datasetId, this.$route.query.token).then(data => {
        this.dataready = true;
        this.dataset = data
        if(this.$route.params.dataviewId)
          this.dataview = data.dataviews[this.$route.params.dataviewId]
        else
          this.dataview = data.dataviews[0]
      })
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>